import { useNavigate } from "react-router-dom";
import { PiShieldCheck } from "react-icons/pi";

const SuccessStep = () => {
  const navigate = useNavigate();

  const goToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="w-full max-w-md space-y-4 text-center">
      <div className="bh-gray-7 rounded-[10px] p-4 bg-black justify-self-center">
        <PiShieldCheck className="text-2xl text-center text-white" />
      </div>
      <div className="space-y-2 mb-8">
        <h1 className="text-2xl font-bold text-gray-7 text-center">
          Password Updated!
        </h1>
        <p className="text-gray-6 text-center">
          Your password has been successfully updated. You can now log in with
          your new password.
        </p>
      </div>
      <button
        onClick={goToLogin}
        className="w-full px-4 py-2 text-white bg-gray-7 rounded-lg hover:bg-gray-6 focus:outline-none focus:ring-1 focus:ring-gray-5 focus:ring-offset-2"
      >
        Go to Login
      </button>
    </div>
  );
};

export default SuccessStep;
